import React, { useState, useEffect } from 'react';
import GeneralView from './Views/GeneralView';
import GeneralEdit from './Views/GeneralEdit';
import EnergyUsageView from './Views/EnergyUsageView';
import EnergyUsageEdit from './Views/EnergyUsageEdit';
import UsageProgramsView from './Views/UsageProgramsView';
import UsageProgramsEdit from './Views/UsageProgramsEdit';
import { LocalPersistence } from "../../../../factories/index";
import { sessionType } from '../../../../interfaces/index';
import { getEnvImpacts, addOrUpdateEnergyusageGeneral, addOrUpdateEnergyusageProgram, addOrUpdateEnergyusageEnergyusage } from '../../../../services/envimpact'
import { Tabs, Card, Button, Form, message } from 'antd';
import ActionButtonsBar from '../../../ui/ActionButtonsBar';
import Loading from './../../../Loading';
import {axios} from '../../../../helpers/axiosService/index';
import commonStyles from './../../../CSIComponents/index.module.css';
import PageContainer from '../../../CSIComponents/PageContainer';

const { TabPane } = Tabs;
interface propsTypes {
  isEditable: void | any,
  cancelEditable: void | any,
  disableTabPanes: void | any,
}
let response: any = {};
const EnergyUsage = (props: propsTypes) => {

  const [form] = Form.useForm();
  const [viewOrEdit, setViewOrEdit] = useState(1);
  const [loadingFlag, setLoadingFlag] = useState(false)
  const [editData, setEditData] = useState<any | null>(null);
  const [generalObj, setGeneralObj] = useState<any | null>(null)
  const [currentTabKey, setCurrentTabKey] = useState('General')
  const [disableFlag, setDisableFlag] = useState(false)
  // const [detailData, setDetailData] = useState<any | null>(null);

  const afterUpdate = () => {
    props.cancelEditable();
    props.disableTabPanes(false)
    setViewOrEdit(1)
    setEditData(null)
    setLoadingFlag(false)
    getEnvImpactsData()
  }

  const onFinish = () => {
    form.validateFields().then(formData => {
      setLoadingFlag(true)
      const generalData = {
        supplier: response?.property?.supplier,
        propertyId: response?.property?.propertyId,
        property: {
          environmentalimpact: {
            id: response?.property?.environmentalimpact?.id,
            langid: response?.property?.environmentalimpact?.langid,
            energyusage: {
              general: {
                efficientappliances: formData.efficientappliances,
                efficientlighting: formData.efficientlighting,
                heatpowercombined: formData.heatpowercombined,
                heatpump: formData.heatpump,
                powersavingpolicy: formData.powersavingpolicy,
                solar: formData.solar,
                tempcontrols: formData.tempcontrols,
                windturbine: formData.windturbine,
                energygeneratedamount: formData.energygeneratedamount,
                energystarrating: formData.energystarrating,
                energyintensityamount: formData.energyintensityamount,
                energyintensityuom: formData.energyintensityuom,
                energyintensitytimeperiod: formData.energyintensitytimeperiod,
              }
            }
          }
        }
      }
      const formValues = Object.keys(formData);
      const dealenergyusageData: { amount: string; uom: string; powertype: string }[] = [];
      formValues.forEach((key: string, i: number) => {
        if (key.includes('firstIptName')) {
          const splitArray = key.split('-');
          const index = splitArray[splitArray.length - 1];
          if (formData[`firstIptName-${index}`] || formData[`secounIptName-${index}`] || formData[`thirdIptName-${index}`]) {
            dealenergyusageData.push({
              amount: formData[`firstIptName-${index}`],
              uom: formData[`secounIptName-${index}`],
              powertype: formData[`thirdIptName-${index}`]
            })
          }
        }
      });

      const energyUsageData = {
        supplier: response?.property?.supplier,
        propertyId: response?.property?.propertyId,
        property: {
          environmentalimpact: {
            id: response?.property?.environmentalimpact?.id,
            langid: response?.property?.environmentalimpact?.langid,
            energyusage: {
              energyusage: dealenergyusageData
            }
          }
        }
      }
      const dealUsageProgramsData: { desc: string; }[] = []
      formValues.forEach((key: string) => {
        if (key.includes('desc')) {
          const splitArray = key.split('-')
          const index = splitArray[splitArray.length - 1]
          if (formData[`desc-${index}`]) {
            dealUsageProgramsData.push({
              desc: formData[`desc-${index}`]
            })
          }
        }
      })
      const usageProgramsData = {
        supplier: response?.property?.supplier,
        propertyId: response?.property?.propertyId,
        property: {
          environmentalimpact: {
            id: response?.property?.environmentalimpact?.id,
            langid: response?.property?.environmentalimpact?.langid,
            energyusage: {
              usageprogram: dealUsageProgramsData
            }
          }
        }
      }
      axios.all([addOrUpdateEnergyusageGeneral(generalData), addOrUpdateEnergyusageEnergyusage(energyUsageData), addOrUpdateEnergyusageProgram(usageProgramsData)]).then(res => {
        afterUpdate()
      }, (err) => {
        message.error({
          content: err?.message || err[0]?.error[0]?.message || err[1]?.error[0]?.message || err[2]?.error[0]?.message
        });
        afterUpdate()
      })
    })
      .catch(() => {
        message.error({
          content: 'Check all the fields please.',
        });
      });
  };
  const callback = (key: any) => {
    setCurrentTabKey(key)
  }
  const cancelClik = () => {
    props.cancelEditable();
    props.disableTabPanes(false)
    setViewOrEdit(1)
  }

  const handleSuccessData = (data: any) => {
    let energyUsageDataEdit: { [x: string]: string; } = {};
    if (data.result.success) {
      setEditData(data.property);
      const energyUsageData = data?.property?.environmentalimpact?.energyusage?.energyusage || [];
      energyUsageData.forEach((item: any, i: number) => {
        energyUsageDataEdit[`firstIptName-${i}`] = item.amount;
        energyUsageDataEdit[`secounIptName-${i}`] = item.uom;
        energyUsageDataEdit[`thirdIptName-${i}`] = item.powertype;
      });
      if (!energyUsageData.length) {
        response.property.environmentalimpact.energyusage.energyusage = [{ uom: ' ' }]
      }
      const UsageProgramsEditData = data?.property?.environmentalimpact?.energyusage?.usageprogram || [];
      let usageProgramsEditData: { [x: string]: string } = {}
      UsageProgramsEditData.forEach((item: any, i: number) => {
        //usageProgramsEditData[`desc-${i}`] = [{ desc: ' ' }]
        usageProgramsEditData[`desc-${i}`] = item.desc
      });

      if (!UsageProgramsEditData.length) {
        response.property.environmentalimpact.energyusage.usageprogram = [{ desc: ' ' }]
      }
      setGeneralObj({
        ...energyUsageDataEdit,
        ...usageProgramsEditData,
        ...data.property.environmentalimpact.energyusage.general
      })
      form.resetFields()
    } else {
      message.error({
        content: data?.error[0]?.message
      });
    }
  }

  const getEnvImpactsData = async () => {
    const get_session = new LocalPersistence('session');
    const session: sessionType = await get_session.getSessionPersistence();
    let supplier = session.supplier;
    let propertyId = session.propertyId;

    getEnvImpacts(supplier, propertyId).then(data => {
      if (data.result.success) {
        response = data
        handleSuccessData(data)
      } else {
        message.error({
          content: data?.error[0]?.message
        });
        response = {}
        setEditData({})
        setGeneralObj({})
      }
      handleSuccessData(data)
      form.validateFields().then(() => {
        setDisableFlag(false)
      }).catch(err => {
        err.errorFields.length ? setDisableFlag(true) : setDisableFlag(false)
      });
    }, err => {
      message.error({
        content: err?.message || err?.error[0]?.message
      });
      response = {}
      setEditData({})
      setGeneralObj({
        // [`firstIptName-1`]: '',
        // [`secounIptName-1`]: '',
        // [`thirdIptName-1`]: '',
        // [`desc-1`]: '',
      })
    }
    )
  }

  useEffect(() => {
    getEnvImpactsData()
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [])
  const editButton = (
    <>
      <Button type="primary" className="db-edit-btn" onClick={() => { setViewOrEdit(2); props.disableTabPanes(true); form.setFieldsValue(generalObj) }}>Edit</Button>
    </>
  )

  if (loadingFlag) return <Loading type="large" />
  return (
    <PageContainer>
      <Card style={{ marginTop: -15, marginBottom: 70 }}>
        {editData && generalObj ? (
          <Form
            form={form}
            layout='vertical'
            onValuesChange={() => {
              form
                .validateFields()
                .then(() => {
                  setDisableFlag(false)
                })
                .catch((err) => {
                  err.errorFields.length
                    ? setDisableFlag(true)
                    : setDisableFlag(false)
                })
            }}>
            <Tabs
              onChange={callback}
              type='card'
              tabBarExtraContent={viewOrEdit == 1 && editButton}
              defaultActiveKey={currentTabKey}>
              <TabPane tab='General' key='general' forceRender={true}>
                {viewOrEdit == 1 ? (
                  <GeneralView dataList={editData} />
                ) : (
                  <GeneralEdit dataList={editData} />
                )}
              </TabPane>
              <TabPane tab='Energy Usage' key='energyUsage' forceRender={true}>
                {viewOrEdit == 1 ? (
                  <EnergyUsageView dataList={editData} />
                ) : (
                  <EnergyUsageEdit dataList={editData} currentForm={form} />
                )}
              </TabPane>
              <TabPane
                tab='Usage Programs'
                key='usagePrograms'
                forceRender={true}>
                {viewOrEdit == 1 ? (
                  <UsageProgramsView dataList={editData} />
                ) : (
                  <UsageProgramsEdit dataList={editData} currentForm={form} />
                )}
              </TabPane>
            </Tabs>
          </Form>
        ) : (
          <>
            <Tabs type='card'>
              <TabPane tab='General' key='general'></TabPane>
              <TabPane tab='Energy Usage' key='energyUsage'></TabPane>
              <TabPane tab='Usage Programs' key='usagePrograms'></TabPane>
            </Tabs>
            <div style={{ marginBottom: '50vh' }}>
              <Loading type='large' />
            </div>
          </>
        )}
      </Card>
      <ActionButtonsBar
        onCancel={cancelClik}
        onSave={onFinish}
        disabledSave={disableFlag}
        show={viewOrEdit !== 1}
      />
    </PageContainer>
  )
}


export default EnergyUsage;
